import React, { useEffect, useState } from 'react';
import { BsArrowLeftShort, BsArrowRightShort } from 'react-icons/bs';
import { useHistory } from 'react-router-dom';

import { saveOnBoardData } from 'api/onBoarding';
import InputField from 'components/FormFields/InputField';
import APFormGroup from 'components/FormFields/APFormGroup';
import { getPutFormat } from './filter';
import './styles.scss';

const getFormattedNumber = (phoneNumber) => {
  const numberDigits = phoneNumber.replace(/ /g, '');
  if (numberDigits && numberDigits.length === 11 && numberDigits[0] === '1') {
    return numberDigits
      .substring(1)
      .replace(/(\d{3})(\d{3})(\d{4})/, '1 ($1) $2-$3');
  }
  if (numberDigits && numberDigits.length === 10) {
    return numberDigits.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  }
  return phoneNumber;
};

const Step4 = ({ formData }) => {
  const history = useHistory();
  const [isSubmitted, setFormSubmitted] = useState(false);

  const [phoneNumber, setPhoneNumber] = useState('');
  const [website, setWebsite] = useState('');
  const [facebook, setFacebook] = useState('');
  const [twitter, setTwiiter] = useState('');
  const [instagram, setInstagram] = useState('');
  const [pinterest, setPinterest] = useState('');

  useEffect(() => {
    const { companyInfo } = formData;
    if (companyInfo) {
      setPhoneNumber(companyInfo.phoneNumber || '');
      setWebsite(companyInfo.website || '');
      setFacebook(companyInfo.facebook || '');
      setTwiiter(companyInfo.twitter || '');
      setInstagram(companyInfo.instagram || '');
      setPinterest(companyInfo.pinterest || '');
    }
  }, [formData]);

  const validURL = (str) => {
    let websiteStr = str;
    if (str.indexOf('www.') > -1) {
      websiteStr = str.substring(str.indexOf('www.') + 4);
    }
    const pattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$',
      'i',
    ); // fragment locator
    return !!pattern.test(websiteStr);
  };

  const isFormFieldsValid = () => {
    if (!website) return true;
    return validURL(website);
  };

  const saveForms = async () => {
    const newFormData = formData;
    newFormData.companyInfo.phoneNumber = phoneNumber;
    newFormData.companyInfo.website = website;
    newFormData.companyInfo.facebook = facebook;
    newFormData.companyInfo.twitter = twitter;
    newFormData.companyInfo.instagram = instagram;
    newFormData.companyInfo.pinterest = pinterest;

    const result = await saveOnBoardData({ boarding: getPutFormat(newFormData) });
    return result;
  };

  const handleBack = () => {
    history.push('/app/v2/account-setup/step/3');
  };

  const handleNext = async () => {
    setFormSubmitted(true);
    if (isFormFieldsValid()) {
      const response = await saveForms();
      if (response) history.push('/app/v2/account-setup/step/5');
    }
  };

  return (
    <>
      <section className="stepflow_content">
        <article className="stepflow_form">
          <section className="stepflow_form-header">
            <h3 className="form-title">Company profile</h3>
            <p className="form-subtitle text-center">
              We'll use this information to populate everything from your
              company settings to your quote and invoice templates. Our promise
              to you—we won't sell, trade or abuse any information you submit to
              us.
            </p>
          </section>
          <APFormGroup
            verticalGap={0}
            horizontalGap={1}
          >
            <InputField
              name="phoneNumber"
              label="Phone number"
              value={phoneNumber}
              onChange={(e) => {
                const phone = e.target.value;
                setPhoneNumber(phone);
              }}
              onBlur={() => {
                const newPhoneNumber = getFormattedNumber(phoneNumber);
                setPhoneNumber(newPhoneNumber);
              }}
            />
            <InputField
              name="website"
              label="Website"
              value={website}
              onChange={(e) => {
                setWebsite(e.target.value);
              }}
              onBlur={() => {
                if (
                  website &&
                  !website.includes('https://') &&
                  !website.includes('http://')
                ) {
                  setWebsite(`http://${  website}`);
                }
              }}
              showError={isSubmitted && !isFormFieldsValid()}
            />
          </APFormGroup>
          <APFormGroup
            title="Social Media"
            className="ap-form-group--mini-label"
            verticalGap={0}
            wrap
          >
            <InputField
              name="facebook"
              value={facebook}
              onChange={(e) => {
                setFacebook(e.target.value);
              }}
              label="facebook.com/"
              wrapperProps={{
                className: 'form-item--inline-label form-item--w-50',
              }}
              labelProps={{
                className: 'form-item__label--unstyled',
              }}
            />
            <InputField
              name="twitter"
              value={twitter}
              onChange={(e) => {
                setTwiiter(e.target.value);
              }}
              label="twitter.com/"
              wrapperProps={{
                className: 'form-item--inline-label form-item--w-50',
              }}
              labelProps={{
                className: 'form-item__label--unstyled',
              }}
            />
            <InputField
              name="instagram"
              value={instagram}
              onChange={(e) => {
                setInstagram(e.target.value);
              }}
              label="instagram.com/"
              wrapperProps={{
                className: 'form-item--inline-label form-item--w-50',
              }}
              labelProps={{
                className: 'form-item__label--unstyled',
              }}
            />
            <InputField
              name="pinterest"
              value={pinterest}
              onChange={(e) => {
                setPinterest(e.target.value);
              }}
              label="pinterest.com/"
              wrapperProps={{
                className: 'form-item--inline-label form-item--w-50',
              }}
              labelProps={{
                className: 'form-item__label--unstyled',
              }}
            />
          </APFormGroup>
        </article>
      </section>
      <section className="stepflow_footer">
        <button className="stepflow_footer-button"
          onClick={handleBack}
        >
          <BsArrowLeftShort size={20} /> Back
        </button>
        {isSubmitted && !isFormFieldsValid() && (
          <div className="stepflow_footer-error">
            Please review and update your website format to continue.
          </div>
        )}
        <button
          className="stepflow_footer-button"
          color="primary"
          onClick={handleNext}
        >
          Next
          <BsArrowRightShort size={20} />
        </button>
      </section>
    </>
  );
};

export default Step4;
